module.exports = __webpack_public_path__ + "e1389983d92fde8d1a38e4c3bc1f777b.svg";